/**
 * Mock data pre žiadosti o nahlédnutí (requests)
 */

import { officials } from "./officials";

const generateDate = (yearsAgo, monthOffset = 0, dayOffset = 0) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - yearsAgo);
  date.setMonth(date.getMonth() + monthOffset);
  date.setDate(date.getDate() + dayOffset);
  return date.toISOString();
};

// State hodnoty pre enum - musia byť objekt s "name" property
// Grid číta state.name cez field: 'state.name'

export const requests = [
  {
    id: "req-001",
    person: {
      firstName: "Martin",
      lastName: "Veselovský",
      email: "martin.veselovsky@denikn.cz",
      phone: "+420222111333",
    },
    officials: [
      {
        id: officials[0].id,
        firstName: officials[0].firstName,
        lastName: officials[0].lastName,
      },
    ],
    officialFullName: `${officials[0].firstName} ${officials[0].lastName}`,
    state: { name: "NEW" },
    text: "Žádám o nahlédnutí do oznámení funkcionáře za účelem novinářské činnosti.",
    created: generateDate(0, 0, -5),
    organization: "Deník N",
    reason: "Novinářská činnost - investigativní článek",
  },
  {
    id: "req-002",
    person: {
      firstName: "Jana",
      lastName: "Novotná",
      email: "jana.novotna@ceskatelevize.cz",
      phone: "+420261132222",
    },
    officials: [
      {
        id: officials[1].id,
        firstName: officials[1].firstName,
        lastName: officials[1].lastName,
      },
      {
        id: officials[10].id,
        firstName: officials[10].firstName,
        lastName: officials[10].lastName,
      },
    ],
    officialFullName: `${officials[1].firstName} ${officials[1].lastName}`,
    state: { name: "ACCEPT" },
    text: "Žádost o nahlédnutí do oznámení senátorů pro pořad Reportéři ČT.",
    created: generateDate(0, -1, -10),
    acceptDate: generateDate(0, -1, -3),
    organization: "Česká televize",
    reason: "Příprava pořadu Reportéři ČT",
  },
  {
    id: "req-003",
    person: {
      firstName: "Petr",
      lastName: "Holec",
      email: "petr.holec@reflex.cz",
      phone: "+420222333444",
    },
    officials: [
      {
        id: officials[2].id,
        firstName: officials[2].firstName,
        lastName: officials[2].lastName,
      },
    ],
    officialFullName: `${officials[2].firstName} ${officials[2].lastName}`,
    state: { name: "REJECT" },
    text: "Žádám o přístup k majetkovému přiznání radního.",
    created: generateDate(0, -2, 0),
    rejectDate: generateDate(0, -1, -15),
    rejectReason: "Nedostatečné odůvodnění žádosti",
    organization: "Reflex",
    reason: "Článek o pražských politicích",
  },
  {
    id: "req-004",
    person: {
      firstName: "Jiří",
      lastName: "Kubík",
      email: "jiri.kubik@firma.seznam.cz",
      phone: "+420234652222",
    },
    officials: [
      {
        id: officials[3].id,
        firstName: officials[3].firstName,
        lastName: officials[3].lastName,
      },
    ],
    officialFullName: `${officials[3].firstName} ${officials[3].lastName}`,
    state: { name: "NEW" },
    text: "Žádost o nahlédnutí do oznámení poslankyně pro Seznam Zprávy.",
    created: generateDate(0, 0, -2),
    organization: "Seznam Zprávy",
    reason: "Přehled majetkových poměrů poslanců",
  },
  {
    id: "req-005",
    person: {
      firstName: "Lenka",
      lastName: "Zlámalová",
      email: "lenka.zlamalova@economia.cz",
      phone: "+420225062222",
    },
    officials: [
      {
        id: officials[4].id,
        firstName: officials[4].firstName,
        lastName: officials[4].lastName,
      },
    ],
    officialFullName: `${officials[4].firstName} ${officials[4].lastName}`,
    state: { name: "ACCEPT" },
    text: "Žádám o zpřístupnění oznámení primátora pro článek v HN.",
    created: generateDate(0, -3, 0),
    acceptDate: generateDate(0, -2, -20),
    organization: "Hospodářské noviny",
    reason: "Srovnávací analýza primátorů krajských měst",
  },
  {
    id: "req-006",
    person: {
      firstName: "Jan",
      lastName: "Bumba",
      email: "jan.bumba@rozhlas.cz",
      phone: "+420221554444",
    },
    officials: [
      {
        id: officials[7].id,
        firstName: officials[7].firstName,
        lastName: officials[7].lastName,
      },
    ],
    officialFullName: `${officials[7].firstName} ${officials[7].lastName}`,
    state: { name: "NEW" },
    text: "Žádost o nahlédnutí do neveřejného oznámení náměstkyně ministra.",
    created: generateDate(0, 0, -8),
    organization: "iROZHLAS.cz",
    reason: "Investigativní reportáž",
  },
  {
    id: "req-007",
    person: {
      firstName: "Radek",
      lastName: "Bartoníček",
      email: "radek.bartonicek@aktualne.cz",
      phone: "+420222555666",
    },
    officials: [
      {
        id: officials[5].id,
        firstName: officials[5].firstName,
        lastName: officials[5].lastName,
      },
      {
        id: officials[8].id,
        firstName: officials[8].firstName,
        lastName: officials[8].lastName,
      },
    ],
    officialFullName: `${officials[5].firstName} ${officials[5].lastName}`,
    state: { name: "ACCEPT" },
    text: "Žádost o nahlédnutí do oznámení představitelů obce Roztoky.",
    created: generateDate(0, -1, -5),
    acceptDate: generateDate(0, 0, -25),
    organization: "Aktuálně.cz",
    reason: "Článek o komunální politice ve Středočeském kraji",
  },
  {
    id: "req-008",
    person: {
      firstName: "Markéta",
      lastName: "Šichtařová",
      email: "marketa@nextfinance.cz",
      phone: "+420222777888",
    },
    officials: [
      {
        id: officials[11].id,
        firstName: officials[11].firstName,
        lastName: officials[11].lastName,
      },
    ],
    officialFullName: `${officials[11].firstName} ${officials[11].lastName}`,
    state: { name: "REJECT" },
    text: "Žádám o přístup k oznámení ředitelky odboru MF.",
    created: generateDate(0, -2, -10),
    rejectDate: generateDate(0, -1, -25),
    rejectReason: "Žadatel není oprávněnou osobou dle zákona",
    organization: "Next Finance",
    reason: "Ekonomická analýza",
  },
  {
    id: "req-009",
    person: {
      firstName: "Ondřej",
      lastName: "Kundra",
      email: "ondrej.kundra@respekt.cz",
      phone: "+420222999000",
    },
    officials: [
      {
        id: officials[6].id,
        firstName: officials[6].firstName,
        lastName: officials[6].lastName,
      },
    ],
    officialFullName: `${officials[6].firstName} ${officials[6].lastName}`,
    state: { name: "ACCEPT" },
    text: "Žádost o nahlédnutí do oznámení bývalého hejtmana.",
    created: generateDate(0, -4, 0),
    acceptDate: generateDate(0, -3, -15),
    organization: "Respekt",
    reason: "Článek o krajské politice",
  },
  {
    id: "req-010",
    person: {
      firstName: "Pavla",
      lastName: "Holcová",
      email: "pavla.holcova@investigace.cz",
      phone: "+420222111999",
    },
    officials: [
      {
        id: officials[0].id,
        firstName: officials[0].firstName,
        lastName: officials[0].lastName,
      },
      {
        id: officials[7].id,
        firstName: officials[7].firstName,
        lastName: officials[7].lastName,
      },
      {
        id: officials[11].id,
        firstName: officials[11].firstName,
        lastName: officials[11].lastName,
      },
    ],
    officialFullName: `${officials[0].firstName} ${officials[0].lastName}`,
    state: { name: "NEW" },
    text: "Hromadná žádost o nahlédnutí do oznámení funkcionářů ministerstev.",
    created: generateDate(0, 0, -1),
    organization: "Investigace.cz",
    reason: "Projekt o střetu zájmů ve státní správě",
  },
  {
    id: "req-011",
    person: {
      firstName: "Adam",
      lastName: "Javůrek",
      email: "adam.javurek@denik.cz",
      phone: "+420222333555",
    },
    officials: [
      {
        id: officials[14].id,
        firstName: officials[14].firstName,
        lastName: officials[14].lastName,
      },
    ],
    officialFullName: `${officials[14].firstName} ${officials[14].lastName}`,
    state: { name: "NEW" },
    text: "Žádost o nahlédnutí do vstupního oznámení nového hejtmana JMK.",
    created: generateDate(0, 0, -3),
    organization: "Deník",
    reason: "Profil nového hejtmana",
  },
  {
    id: "req-012",
    person: {
      firstName: "Kristýna",
      lastName: "Zelienková",
      email: "kristyna.zelienkova@idnes.cz",
      phone: "+420222444666",
    },
    officials: [
      {
        id: officials[9].id,
        firstName: officials[9].firstName,
        lastName: officials[9].lastName,
      },
    ],
    officialFullName: `${officials[9].firstName} ${officials[9].lastName}`,
    state: { name: "ACCEPT" },
    text: "Žádost o přístup k oznámení radní pro územní rozvoj.",
    created: generateDate(0, -2, -5),
    acceptDate: generateDate(0, -1, -20),
    organization: "iDNES.cz",
    reason: "Série článků o pražské výstavbě",
  },
];

// Žiadosti pre verejnosť (RequestPublic)
export const requestsPublic = requests.map((req) => ({
  id: req.id,
  text: req.text,
  state: req.state,
  created: req.created,
}));

export default requests;
